import { render, staticRenderFns } from "./Rubros.vue?vue&type=template&id=7de743a6&scoped=true&"
import script from "./Rubros.vue?vue&type=script&lang=js&"
export * from "./Rubros.vue?vue&type=script&lang=js&"
import style0 from "./Rubros.vue?vue&type=style&index=0&id=7de743a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de743a6",
  null
  
)

export default component.exports